
class MenuArticleSlider extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback() {
        new Swiper(this.querySelector('.swiper'), {
            spaceBetween: 10,
            slidesPerView: 4,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }

        });
    }
}
customElements.define('menu-slider', MenuArticleSlider);


class SwiperSlider extends HTMLElement {
    constructor(){
      super();
      this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
      this.selector = this.dataset.selector;
      
      this.actionSwiper;
    }

    connectedCallback() {
        if (this.querySelector(`.collection-carousel__collection-wrapper.${this.selector}`)) {
            this.collectionCarousellSlider();
        } 
        else {
            this.productActionSlider();
        }
    }

    static get observedAttributes() {
      return ['data-reset'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
        if (oldValue == "false") {
        this.setAttribute('data-reset', "false");
        }
    }
  
    // Slider for the section 'collection-carousell.liquid'
    collectionCarousellSlider() {
        const self = this;
        let swiper;
        let carouselSwiperInitialized = false;

        if(Swiper !== 'undefined'){
            let collection_carousel_swiper = this.querySelector(`.collection-carousel__collection-wrapper.${this.selector}`);
            let collection_carousel_slides = this.querySelectorAll('.swiper.collection-carousel__collection-wrapper .swiper-slide.collection-carousel-card');
            let collection_carousel_slides_cloned = this.querySelectorAll('.swiper.collection-carousel__collection-wrapper .swiper-slide.collection-carousel-card.cloned-slides');

            /**
             * Checking the data-attribute 'data-delay-observer'
             * If true an observer checks when slides are added and then Swiper is initialized
             */
                if ( collection_carousel_slides.length <= 3 ) {
                    if (window.matchMedia( '(max-width:768px)' ).matches) {                    
                        swiper = new Swiper(collection_carousel_swiper, self.options);
                        carouselSwiperInitialized = true;
                    }
                } else {
                    this.cloneSlides(collection_carousel_slides, collection_carousel_slides_cloned);
                    swiper = new Swiper(collection_carousel_swiper, self.options);
                    carouselSwiperInitialized = true;
                }

            // Check done at resize, to check whether to initialize or destroy the slider
            window.addEventListener("resize", function(event) {
                if ( collection_carousel_slides.length <= 3 ) {
                    if ( window.matchMedia( '(max-width:768px)' ).matches && carouselSwiperInitialized == false ) {
                        swiper = new Swiper(collection_carousel_swiper, self.options);
                        carouselSwiperInitialized = true;
                    } else if (!window.matchMedia( '(max-width:768px)' ).matches && carouselSwiperInitialized == true ) {
                        swiper.destroy();
                        carouselSwiperInitialized = false;
                    }
                } 
            });
        }
    }

    // To solve the loop "problem" from version 8+ (total number of slides must be >= slidesPerView * 2)
    // Before initializing swiper, the slides are cloned
    cloneSlides(slides, clonedSlides) {
        if (clonedSlides.length == 0) {
            slides.forEach((element) => {
              const clonedElement = element.cloneNode(true);
              clonedElement.classList.add("cloned-slide");
              element.parentNode.appendChild(clonedElement);
            });
        }   
    }

    productActionSlider() {
        const self = this;
        if (Swiper !== 'undefined') {
            let actionSwiperElement = document.querySelector('.product-action--swiper');
            let actionSlides = this.querySelectorAll('.product-action--swiper li');
            if (actionSlides.length > 0) {
                this.actionSwiper = new Swiper(actionSwiperElement, self.options);

                document.querySelectorAll('.main-product-action li').forEach(function(element) {
                    let buttonToTrigger = element.querySelector('modal-opener button');
                    
                    element.addEventListener('click', function() {
                      buttonToTrigger.click();
                    })

                    let zoomTrigger = element.querySelector('.tw-pdp-zoom-trigger');
                    if (zoomTrigger) {
                        zoomTrigger.addEventListener('click', function() {
                          buttonToTrigger.click();
                        });
                    }
                });

            }
        }
    }
}

customElements.define('swiper-slider', SwiperSlider);

class ProductSwiper extends HTMLElement {
    constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.mobileSlidesPerView = this.dataset.mobileSlidesPerView || 1.5
        this.desktopSlidesPerView = this.dataset.desktopSlidesPerView || 4
        this.mobileSpace = this.dataset.mobileSpace || 5
        this.desktopSpace = this.dataset.desktopSpace || 10
        this.loop = this.dataset.loop || false;
  
        this.enableSwiper();
    }
  
    enableSwiper() {
        const slidePerView = this.isMobile ? this.mobileSlidesPerView :  this.desktopSlidesPerView ;
        const space = this.isMobile ? this.mobileSpace : this.desktopSpace;
  
        const configuration =  {
          slidesPerView: slidePerView,
          spaceBetween: space,
          loop: this.loop,
          navigation: {
              nextEl: ".swiper-pagination-next",
              prevEl: ".swiper-pagination-prev",
              clickable: true
          }
      }
  
      if (this.isMobile) {
        configuration['pagination'] = {
          el: ".swiper-pagination",
          type: "progressbar",
        } 
      }
  
      new Swiper(this.querySelector('.swiper-container'), configuration);
    }
  }
  
  customElements.define('product-swiper', ProductSwiper);